import {
  GET_STOCK_REPORT,
  GET_STOCK_REPORT_SUCCESS,
  GET_STOCK_REPORT_ERROR,
  GET_INVENTORY_DETAILS,
  GET_INVENTORY_DETAILS_SUCCESS,
  GET_INVENTORY_DETAILS_ERROR,

} from "../actions/inventoryAction";

const initialState = {
  stockReportData: {}, 
  inventoryDetailsData: {}, 
  loading: false,
  loaded: false,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_STOCK_REPORT:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case GET_STOCK_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        stockReportData: action.payload.success,
      };

    case GET_STOCK_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        stockReportData: [],
      };

    case GET_INVENTORY_DETAILS:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case GET_INVENTORY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        inventoryDetailsData: action.payload.success,
      };

    case GET_INVENTORY_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        inventoryDetailsData: [],
      };

    default:
      return state;
  }
}
